import { render, staticRenderFns } from "./Ping.vue?vue&type=template&id=064d1134&scoped=true&"
import script from "./Ping.vue?vue&type=script&lang=js&"
export * from "./Ping.vue?vue&type=script&lang=js&"
import style0 from "./Ping.vue?vue&type=style&index=0&id=064d1134&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064d1134",
  null
  
)

export default component.exports